import React, { useContext } from 'react';
import { connect } from 'react-redux';
import clsx from 'clsx';
import { Typography } from '@americanexpress/aqx-components';
import { getDynAppBannerData } from './redux';
import { sendDTMClickEvent } from 'service_modules/models/dtm-tagging';
import { DynamicAppModalContext } from 'src/universal/components/DynamicApp/redux';

import defaultStyles from './__styles__/index.scss?modules';

const DynAppBanner = ({ bannerData, needTopMargin = false, ctaRef, custStyles }) => {
  const setIsDynamicModalOpen = useContext(DynamicAppModalContext);
  const { header, cta, subHeader } = bannerData;
  const isLightBackground = bannerData?.isLightBackground;
  const styles = custStyles || defaultStyles;

  return (
    <div
      className={clsx(styles.dynAppBanner, {
        [styles.isWhiteBack]: isLightBackground,
        [styles.needTopMargin]: needTopMargin
      })}
    >
      <Typography className={styles.header} Component="h2">
        {header}
      </Typography>
      <div className={styles.subHeader}>
        <button
          ref={ctaRef}
          onClick={() => {
            setIsDynamicModalOpen();
            sendDTMClickEvent(cta.dtm);
          }}
          title={cta.text}
          className={styles.cta}
          tabIndex={0}
        >
          {cta.text}
        </button>
        <Typography className={styles.subHeaderText} Component="span">
          {subHeader}
        </Typography>
      </div>
    </div>
  );
};

const mapStateToProps = (state, ownPros) => {
  const { bannerDataInjected } = ownPros;
  return {
    bannerData: bannerDataInjected || getDynAppBannerData(state)
  };
};

export default connect(mapStateToProps)(React.memo(DynAppBanner));
